import Vue from "vue";
import Vuex from "vuex";
import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";
import sidebar from "./modules/sidebar";
import header from "./modules/header";
import footer from "./modules/footer";
import auth from "./modules/auth";
import seo from "./modules/seo";
import tag from "./modules/tag";
import advise from "./modules/advise";
import brand from "./modules/brand";
import news from "./modules/news";
import attribute from "./modules/attribute";
import order from "./modules/order";
import category from "./modules/category";
import configs from "./modules/configs";
import production from "./modules/production";
import support from "./modules/support";
import warranty from "./modules/warranty";
import residence from "./modules/residence";
import showroom from "./modules/showroom";
import product_error from "./modules/product_error";
import comments from "./modules/comments";
import setting from "./modules/setting";
import translation from "./modules/translation";
import theme from "./modules/theme";
import confignew from "./modules/confignew";
import category_post from "./modules/category_post";
import promotion_gift from "./modules/promotion_gift";
import regions from "./modules/regions";
import warranties_center from "./modules/warranties_center";
import renew from "./modules/renew";
import user from "./modules/user";
import role from "./modules/role";
import permission from "./modules/permission";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  getters,
  mutations,
  actions,
  modules: {
    auth,
    category,
    renew,
    user,
    role,
    permission,
    category_post,
    brand,
    tag,
    confignew,
    comments,
    warranty,
    news,
    advise,
    product_error,
    attribute,
    production,
    setting,
    configs,
    support,
    residence,
    showroom,
    order,
    seo,
    promotion_gift,
    regions,
    warranties_center,
    navigations: {
      namespaced: true,
      modules: {
        header,
        sidebar,
        footer,
      },
    },
    scheme: {
      namespaced: true,
      modules: {
        theme,
      },
    },
    translation,
  },
});
